import { ChevronRight } from 'lucide-react'
import { Link } from 'react-router-dom'

import { cn } from '../../lib/utils'

export interface Crumb {
  label: string
  /** Omit on the last crumb — the page you are already on. */
  to?: string
}

/** "You are here" for deep routes.
 *
 * The final crumb is plain text carrying `aria-current="page"` rather than a
 * link to the page you are already on, which is a screen-reader dead end.
 */
export function Breadcrumbs({ items, className }: { items: Crumb[]; className?: string }) {
  if (items.length === 0) return null

  return (
    <nav aria-label="Breadcrumb" className={cn('min-w-0', className)}>
      <ol className="flex flex-wrap items-center gap-1 text-xs text-muted-foreground">
        {items.map((item, index) => {
          const last = index === items.length - 1
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-1">
              {index > 0 && <ChevronRight className="size-3 shrink-0 opacity-60" aria-hidden />}
              {item.to && !last ? (
                <Link to={item.to} className="transition-colors hover:text-foreground">
                  {item.label}
                </Link>
              ) : (
                <span className={cn('truncate', last && 'font-medium text-foreground')} aria-current={last ? 'page' : undefined}>
                  {item.label}
                </span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
